import React from 'react'
import { Box, TextBody } from '@ally/metronome-ui'
import { asCurrency } from '@ally/aos-utils'
import { getDashDash } from '../../../utils'
import { useAccountTypes } from '../../../AccountTypeContext'
import TotalBalanceDejarg from './TotalBalanceDejarg'

const WidgetFooter: React.FC = () => {
  const {
    groupedBankAccounts,
    hasStaleInvestAccounts,
    totalBalanceOfBankAndInvest,
  } = useAccountTypes()
  const investOnlyUser = !Object.keys(groupedBankAccounts).length

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Box display="flex" alignItems="center">
        <TotalBalanceDejarg />
        <TextBody tag="span" size="md" weight="bold">
          &nbsp;Total
        </TextBody>
      </Box>
      <TextBody tag="span" size="sm" weight="bold">
        {hasStaleInvestAccounts && investOnlyUser
          ? getDashDash(
              'We can’t update your account information right now, but we’re working on it.',
            )
          : asCurrency(totalBalanceOfBankAndInvest?.toString())}
      </TextBody>
    </Box>
  )
}

export default WidgetFooter
